/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Esconde por completo as opções de variante que não existem para a
  // combinação atualmente selecionada (ex: cor "Dourado Rosa" quando o
  // tipo de animal "Cão" está selecionado), em vez de as mostrar visíveis
  // mas marcadas como "indisponível". O tema já adiciona a classe
  // "unavailable" ao <input> dessas opções sempre que a seleção muda
  // (ver assets/theme.js, classe "sellout").
  //
  // IMPORTANTE: só aplicamos isto à opção "Cor" (data-option-position="2"
  // no Colar do Abraço Eterno, após a opção "Género" ter sido removida).
  var style = document.createElement('style');
  style.textContent = [
    '.selector-wrapper[data-option-position="2"] radio-swatch:has(input.unavailable),',
    '.selector-wrapper[data-option-position="2"] .radio__button:has(input.unavailable),',
    '.selector-wrapper[data-option-position="2"] .select-popout__item:has(a.unavailable) {',
    '  display: none !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  // A opção "Animal" (Cão/Gato, data-option-position="1") deve ficar
  // SEMPRE clicável, mesmo quando a cor atualmente escolhida só existe
  // para o animal atual. O CSS próprio do tema impede o clique
  // (pointer-events) em qualquer opção marcada com a classe
  // "unavailable"/"sold-out", que o tema aplica automaticamente sempre
  // que a combinação atual não existe. Garantimos aqui que essas
  // classes NUNCA chegam a ficar nos botões de Animal.
  function limparAnimalIndisponivel() {
    document
      .querySelectorAll('.selector-wrapper[data-option-position="1"] input.unavailable, .selector-wrapper[data-option-position="1"] input.sold-out')
      .forEach(function (input) {
        input.classList.remove('unavailable', 'sold-out');
      });
  }

  limparAnimalIndisponivel();

  var animalObserver = new MutationObserver(function () {
    limparAnimalIndisponivel();
  });

  animalObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });

  // Quando o cliente clica em "Cão" ou "Gato" e a cor atualmente
  // escolhida não existe para esse animal, salta automaticamente para
  // a primeira cor disponível desse animal (em vez de deixar a
  // seleção "vazia" e o botão de compra a dizer "Indisponível").
  function obterProductJSON() {
    var script = document.querySelector('[data-product-json]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function chaveDaOpcao(product, nome) {
    if (!product || !product.options) return null;
    var idx = product.options.indexOf(nome);
    return idx === -1 ? null : 'option' + (idx + 1);
  }

  function saltarParaPrimeiraCorDisponivel(inputAnimal) {
    var product = obterProductJSON();
    if (!product) return;

    var chaveAnimal = chaveDaOpcao(product, 'Animal');
    var chaveCor = chaveDaOpcao(product, 'Cor');
    if (!chaveAnimal || !chaveCor) return;

    var novoAnimal = inputAnimal.value;
    var inputCorAtual = document.querySelector('input[name^="options[Cor]"]:checked');
    var corAtual = inputCorAtual ? inputCorAtual.value : null;

    var combinacaoValida = product.variants.some(function (v) {
      return v[chaveAnimal] === novoAnimal && v[chaveCor] === corAtual;
    });
    if (combinacaoValida) return;

    var candidatas = product.variants.filter(function (v) {
      return v[chaveAnimal] === novoAnimal;
    });
    if (!candidatas.length) return;

    var alvo = candidatas.filter(function (v) { return v.available; })[0] || candidatas[0];
    var corAlvo = alvo[chaveCor];

    document.querySelectorAll('input[name^="options[Cor]"]').forEach(function (input) {
      if (input.value === corAlvo && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  document.addEventListener('change', function (e) {
    var alvo = e.target;
    if (alvo && alvo.matches && alvo.matches('input[name^="options[Animal]"]')) {
      setTimeout(function () { saltarParaPrimeiraCorDisponivel(alvo); }, 0);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
